var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHolders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4 9.8V11H0V9.8C0 9.8 0 7.40001 4.2 7.40001C8.4 7.40001 8.4 9.8 8.4 9.8ZM6.3 4.10002C6.3 3.68468 6.17684 3.27866 5.94609 2.93332C5.71534 2.58798 5.38736 2.31882 5.00364 2.15987C4.61991 2.00093 4.19767 1.95934 3.79031 2.04037C3.38295 2.1214 3.00877 2.32141 2.71508 2.6151C2.42139 2.90879 2.22138 3.28297 2.14035 3.69033C2.05932 4.09769 2.10091 4.51993 2.25985 4.90365C2.4188 5.28737 2.68796 5.61535 3.0333 5.8461C3.37865 6.07685 3.78466 6.20001 4.2 6.20001C4.75695 6.20001 5.2911 5.97876 5.68492 5.58494C6.07875 5.19111 6.3 4.65697 6.3 4.10002ZM8.364 7.40001C8.73285 7.68546 9.03466 8.04827 9.24821 8.46291C9.46175 8.87755 9.58183 9.33396 9.6 9.8V11H12V9.8C12 9.8 12 7.62201 8.364 7.40001ZM7.8 2.00002C7.38707 1.9981 6.98328 2.12154 6.642 2.35402C7.00646 2.86326 7.20243 3.47379 7.20243 4.10002C7.20243 4.72624 7.00646 5.33677 6.642 5.84601C6.98328 6.07849 7.38707 6.20193 7.8 6.20001C8.35695 6.20001 8.8911 5.97876 9.28493 5.58494C9.67875 5.19111 9.9 4.65697 9.9 4.10002C9.9 3.54306 9.67875 3.00892 9.28493 2.6151C8.8911 2.22127 8.35695 2.00002 7.8 2.00002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolders);
export default __webpack_public_path__ + "static/media/holders.b933103b22e7d13ee3d25149a3d1d79a.svg";
export { ForwardRef as ReactComponent };